(function (angular) {
	'use strict';

	angular.module('investmentGoalChartModule', [
		'coreModule',
		'loaderModule',
		'momentModule'
	]);
})(window.angular);